// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2023-2024 (original work) Open Assessment Technologies SA ;
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';
import config from '@/config';

export const routing = [
    {
        path: [config.routes.dashboards.dashboard],
        guard: getPermissionsGuard([{ resource: 'portal.dashboard', scopes: ['view'] }]),
        controller: () => import('@/modules/dashboards/controllers/dashboard')
    }
];
